const $ = jQuery.noConflict();

class Inputs {
	constructor(
		trigger = 'input',
		 
	) {
		this.trigger = trigger;
	}
	init() {
		$(this.trigger).on('click', this.setStyate); 
	}
	setStyate(e) {
		e.preventDefault();
		$(this).parent().addClass('focused');
	} 
}

const inputs = function(){
	 var inputs = $('input');
	 inputs.each(function(){
		$(this).on('click', function(){
			
			$('.input-holder').removeClass('focused');
			$(this).closest('.input-holder').addClass('focused');
		} );
	 })

	 const input = document.querySelector("input[type=tel]");
	 intlTelInput(input, {
		initialCountry: "auto",
		geoIpLookup: function(callback) {


			$.get('https://ipinfo.io/?token=002264728ecf8c', function() {}, "jsonp").always(function(resp) {
			  var countryCode = (resp && resp.country) ? resp.country : "us";
			   
			  callback(countryCode);
			});
		  },
	});
	



	 
	
}

export default inputs;
